module.exports = __webpack_public_path__ + "img/Freespin_l1.efbf6bcb.png";